import LogoEduzz from 'assets/images/logo-eduzz-blue.svg';
import Maitenance from 'assets/images/maintenance.svg';

import styles from './styles.module.css';

const Maintenance = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <img className={styles.imageError} src={Maitenance} alt='imagem com duas pessoas e um site de fundo' />
        <div className={styles.messageWrapper}>
          <h3>OPS!</h3>
          <h4>Estamos em manutenção, tente voltar mais tarde.</h4>
        </div>
      </div>
      <footer className={styles.footer}>
        <img className={styles.eduzzLogo} src={LogoEduzz} alt='logo eduzz horizontal' />
        <span className={styles.copyright}>Eduzz 2022. Todos os direitos reservados.</span>
      </footer>
    </div>
  );
};
export default Maintenance;
